module.exports = __webpack_public_path__ + "img/rogers-waterfront.1921ee0c.jpg";